module.exports = __webpack_public_path__ + "static/media/logo.431bee83.jpg";